import React, { Component } from 'react';
import sanitizeHtml from 'sanitize-html-react';

import defaultBanner from '../assets/img/banners/reward-shop-icon-700-x-220-int.png';
import biggerDefaultBanner from '../assets/img/banners/reward-shop-icon-700-x-220-int@2x.png';
import LocResourcesContext, { LocResourcesContextProps } from '../contexts/LocResourcesContext';
import { Domain, Locale } from '@zooplus/commons-lang';
import { View } from '../utils/types';

const imageRoute = require.context('../assets/img/banners/custom-banner', true);
const GLOBAL_PREFIX = 'loy-bppo-bannerContainer';

interface BannerProps {
  siteDomain: Domain;
  locale: Locale;
  view: View;
  defaultTitle: string;
  defaultSubtitle: string;
  bannerName: string;
  showNewSimplifiedBanner: boolean;
}

interface BannerStates {
  siteDomain: Domain;
  defaultTitle: string;
  defaultSubtitle: string;
  bannerName: string;
  showNewSimplifiedBanner: boolean;
  customBannerNotFound: boolean;
}

export default class Banner extends Component<BannerProps, BannerStates> {
  constructor(props: BannerProps) {
    super(props);

    const { siteDomain, view, defaultTitle, defaultSubtitle, bannerName, showNewSimplifiedBanner } =
      this.props;

    this.state = {
      siteDomain: siteDomain,
      defaultTitle: defaultTitle,
      defaultSubtitle: defaultSubtitle,
      customBannerNotFound: false,
      bannerName: `${view}-${bannerName}`,
      showNewSimplifiedBanner: showNewSimplifiedBanner,
    };
  }

  onFormatLocale(localeKey: string, params: any = undefined): string {
    return (this.context as LocResourcesContextProps).onFormatLocale?.(localeKey, params);
  }

  getCustomBanner() {
    try {
      if (this.props.siteDomain === 'zooplus.ch') {
        const lang = this.props.locale.split('_')[0];
        return imageRoute(`./${this.state.siteDomain}/${lang}/${this.state.bannerName}`);
      } else {
        return imageRoute(`./${this.state.siteDomain}/${this.state.bannerName}`);
      }
    } catch (e) {
      this.setState({ customBannerNotFound: true });
    }
  }

  defaultHeader() {
    if (this.state.showNewSimplifiedBanner) {
      return (
        <header className={`${GLOBAL_PREFIX}__title`}>
          <h1>{this.onFormatLocale?.('mzp.overview.bonus-program.view-reward-shop')}</h1>
        </header>
      );
    } else {
      return (
        <header className={GLOBAL_PREFIX}>
          <div className={`${GLOBAL_PREFIX}__content`}>
            <h1>{this.onFormatLocale?.(this.state.defaultTitle)}</h1>
            <p>
              <span
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(this.onFormatLocale?.(this.state.defaultSubtitle)),
                }}
              />
            </p>
          </div>
          <div className={`${GLOBAL_PREFIX}__image`}>
            <img
              src={defaultBanner}
              srcSet={defaultBanner + ' 1x,' + biggerDefaultBanner + ' 2x'}
              alt=""
              aria-hidden
            />
          </div>
        </header>
      );
    }
  }

  getHeader() {
    return (
      <header className={GLOBAL_PREFIX}>
        <img
          id="custom-banner"
          className={`${GLOBAL_PREFIX}__image`}
          src={this.getCustomBanner()}
          alt=""
          aria-hidden
        />
      </header>
    );
  }

  render() {
    if (this.state.customBannerNotFound) {
      return this.defaultHeader();
    } else {
      return this.getHeader();
    }
  }
}
Banner.contextType = LocResourcesContext as React.Context<LocResourcesContextProps>;
